import { LogoutOptions, useAuth0 } from '@auth0/auth0-react';
import { useRouterContext } from '@/shared/router';

export const useLogout = () => {
  const { logout: auth0Logout, isLoading } = useAuth0();
  const { setActiveOrganization } = useRouterContext();

  const logout = (options?: LogoutOptions | undefined) => {
    setActiveOrganization();
    auth0Logout(options);
  };

  return { logout, isLoading };
};
